import classNames from "classnames";
import Icon from "@hudson/ui/components/Icon";
import useServiceExtras from "@lib/use_service_extras";

function PassengersAndExtras({
  className,
  res,
  serviceArea,
  vertical = false,
}: {
  className?: string;
  res: be.Reservation;
  serviceArea?: number;
  vertical?: boolean;
}): JSX.Element {
  const { data } = useServiceExtras(serviceArea, res.service?.serviceExtrasAlias || "");

  return (
    <div
      className={classNames(
        "flex justify-between gap-x-8",
        { "flex-col-reverse gap-y-3": vertical },
        className,
      )}
    >
      <div className="flex shrink flex-wrap justify-start gap-x-6 gap-y-4">
        <div className="flex text-sm font-number text-gray-600">
          {res.passengers?.reduce((acc, psgr) => acc + Number(psgr.value), 0)}{" "}
          <Icon type="person" className="relative -top-0.5 h-5 w-5 ml-2" aria-hidden="true" />
        </div>
        {Number(res.bagCount) > 0 && (
          <div className="flex text-sm font-number text-gray-600">
            {res.bagCount}
            <Icon type="bag" className="h-5 w-5 relative -top-0.5 ml-2" aria-hidden="true" />
          </div>
        )}
      </div>

      {res.serviceExtras && (
        <ul className="grow">
          {res.serviceExtras
            .filter((extra) => extra.value && Number(extra.value) > 0)
            .map((extra) => {
              const svcExtra = data?.serviceExtras?.find(
                (se: be.ServiceExtra) => se.fieldName == extra.field,
              );
              if (!svcExtra) return;
              let count: number | undefined;
              if (!svcExtra.fixedAmount && extra.value && Number(extra.value) > 1)
                count = Number(extra.value);

              return (
                svcExtra && (
                  <li
                    className="whitespace-nowrap text-sm font-number text-gray-600"
                    key={extra.field}
                  >
                    {count && <span>{count}&nbsp;</span>}
                    {svcExtra.label}
                  </li>
                )
              );
            })}
        </ul>
      )}
    </div>
  );
}

export default PassengersAndExtras;
